export const ProjectRepotRouting = [
  {
    path: "/report-center/download/project-repot/list",
    name: "material-project-repot-list",
    meta: { title: "项目经营报表" },
    component: () =>
      import(
        /* webpackChunkName: "project-repot" */ "@/views/report-center/project-repot/list/index.vue"
      ),
  },
];
